export default "__VITE_ASSET__44184378__"